import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "../../context/AuthContext";
import { CartProvider } from "../../context/CartContext";

const AppProviders = ({ children }) => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>{children}</CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppProviders;






